/**
 * Converte um File para sua representação em base64 (sem o prefixo data URL).
 * Rejeita a Promise em caso de erro de leitura, resultado inesperado ou formato inválido.
 */
export const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('Falha ao ler arquivo'));
        reader.onload = () => {
            const result = reader.result;
            if (typeof result !== 'string') {
                reject(new Error('Resultado inesperado do FileReader'));
                return;
            }
            const commaIndex = result.indexOf(',');
            if (commaIndex < 0) {
                reject(new Error('Formato de Data URL inválido'));
                return;
            }
            resolve(result.substring(commaIndex + 1));
        };
        reader.readAsDataURL(file);
    });
